import PrefixEnum from '../prefixes'

export default Object.freeze({
    'www.sweat-and-dance.com': PrefixEnum.IVANA_SANTACRUZ,
    'sweat-and-dance.com': PrefixEnum.IVANA_SANTACRUZ,
    'www.sweat-and-dance.de': PrefixEnum.IVANA_SANTACRUZ,
    'sweat-and-dance.de': PrefixEnum.IVANA_SANTACRUZ,
})
